import React, { useState } from "react";
import "./ExtensionCard.css"; // Optional: for styling purposes
import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import logo from "../../assets/images/favicon.png";
// import { toast } from "react-toastify";
// import { installExtension } from "../../constant/constant";

const ExtensionCard = (props) => {
  const { handleToggle, isDisable, isExtEnabled } = props;

  // const handleDisabledClick = () => {
  //   toast.error(installExtension);
  // };
  const onToggleChange = async (event) => {
    if (isExtEnabled) {
      await handleToggle(event);

      window.location.reload();
    }
  };

  return (
    <div className="Card shadow-sm  rounded position-relative ext">
      <div className="Card-body">
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex logo_cart_flex">
            <div className="me-4 img-container">
              <img src={logo} className="img-fluid rm-logo"></img>
            </div>
            <div>
              <h5 className="card-title">
                READMAX <span className="text-muted">1.1.4</span>
              </h5>
              <p className="card-text">
                Readmax extension is used to improve reading skills.
              </p>
            </div>
          </div>
          {/* Move the toggle switch to the top-right corner */}
          {/* <div className="form-check form-switch">
            <Tooltip title={isDisable ? "Deactivate" : "Activate"}>
              <div
                onClick={() => {
                  if (!isExtEnabled) {
                    handleDisabledClick(); // Trigger toast if extension is not installed
                  }
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!isExtEnabled}
                      checked={isDisable ? true : false}
                    />
                  }
                  onChange={handleToggle}
                />
              </div>
            </Tooltip>
          </div> */}
          <div className="form-check form-switch">
            <Tooltip title={isDisable ? "Deactivate" : "Activate"}>
              <span>
                {" "}
                {/* Tooltip disabled element par kaam nahi karta, isliye span wrapper */}
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!isExtEnabled}
                      checked={!!isDisable}
                      // checked={isDisable ? true : false}
                      onChange={onToggleChange}
                    />
                  }
                  label=""
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <p className="text-center pt-2 mb-0 mt-2">
          <small className="text-muted">
            You can use the toggle switch in this interface to enable or disable
            the Chrome extension.
          </small>
        </p>
      </div>
    </div>
  );
};

export default ExtensionCard;
